
 const productsData =
 [
    {
        "name": "Vacation Bodysuits",
        "description": "OQQ Women's Bodysuits Ruched LCrew Neck ong Sleeve Lounge Stretch Vacation Bodysuits",
        "unique_id": "HA191096P",
        "url_slug": "vacation-bodysuits",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "81c22888bfdd4263965dd8e9f7711d19",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T18:06:59",
        "last_updated": "2024-10-20T18:09:16",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "81c22888bfdd4263965dd8e9f7711d19",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "dc0a563319aa448097d21f49a8b099fb.jpg",
                "url": "hanifah-ali/product_vacation_bodysuits_41a5e6_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            },
            {
                "model_name": "products",
                "model_id": "81c22888bfdd4263965dd8e9f7711d19",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "e02f6f1996b942a3bbf97a69bc8f1cd7.jpg",
                "url": "hanifah-ali/product_vacation_bodysuits_9ba953_2.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 2
            }
        ],
        "current_price": [
            {
                "USD": [
                    65.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 0.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Slim Fit T-Shirts",
        "description": "Askdeer Men's V Neck Polo Shirts Long Sleeve/Short Sleeve Muscle Slim Fit T-Shirts Knit Soft Classic Golf Tee",
        "unique_id": "HA191095P",
        "url_slug": "slim-fit-t-shirts",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "9b369da996704aebb7c31bea252169d9",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T18:05:07",
        "last_updated": "2024-10-20T18:05:25",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "9b369da996704aebb7c31bea252169d9",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "831dc44109d64197a5f5348c6d204820.jpg",
                "url": "hanifah-ali/product_slim_fit_t_shirts_a28ebd_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    20.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 3.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Steel Gold Necklace",
        "description": "3 Pcs Chain Necklace for Men, 4mm Stainless Steel Gold Black and Silver Wheat Chains for Mens Boys Jewelry Gift, 16\"/20\"/24\"/28\"/32 Inches",
        "unique_id": "HA191094P",
        "url_slug": "tonia-silk",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "c34be6403c2a494c8b82396956581253",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T17:27:09",
        "last_updated": "2024-10-20T17:32:56",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "c34be6403c2a494c8b82396956581253",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "1e00501d1214425489de852ad2576ca2.jpg",
                "url": "hanifah-ali/product_tonia_silk_a84429_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    100.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 0.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Hustla Teeth Grillz ",
        "description": "TOPGRILLZ Grillz Gold Poker Grills for Your Teeth Heart Hip Hop Grillz Teeth Men Diamond Grillz for Men Women 18K Gold Plated Hustla Teeth Grillz Gold Jewelry Rapper Costume",
        "unique_id": "HA191092P",
        "url_slug": "hustla-teeth-grillz",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "bca9d949ac654213968edc5f4870558a",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "all",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-20T14:40:30",
                "id": "ab4eb4a826a2464386dc27fee53c8c3c",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-20T14:40:30",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:53:11",
        "last_updated": "2024-10-20T16:53:30",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "bca9d949ac654213968edc5f4870558a",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "ee727516d01c44199ae6a754c9ac5046.jpg",
                "url": "hanifah-ali/product_hustla_teeth_grillz_2b4fd2_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    250.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 6.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "18K gold-plated earrings",
        "description": "CW 18K gold-plated green long dangle earrings, exaggerated square frosted gold large womens earrings, Very dynamic and attractive holiday earrings for women trendy.",
        "unique_id": "HA191091P",
        "url_slug": "ndy",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "ce6321e0b59f47dc8e1e37a4240970e6",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:51:20",
        "last_updated": "2024-10-20T16:51:49",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "ce6321e0b59f47dc8e1e37a4240970e6",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "0f3bf48559254365929399fe20981c25.jpg",
                "url": "hanifah-ali/product_ndy_8c9a32_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    40.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 5.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": " Leverback Dangle Earrings",
        "description": "Austrian Crystal Teardrop Leverback Dangle Earrings for Women Fashion 14K Gold Plated Hypoallergenic Jewelry",
        "unique_id": "HA191090P",
        "url_slug": "austrian-crystal-teardrop-leverback-dangle-earrings-for-women-fashion-14k-gold-plated-hypoallergenic-jewelry",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "4d7255e69d2546549053998155f0a895",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:49:09",
        "last_updated": "2024-10-20T16:49:35",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "4d7255e69d2546549053998155f0a895",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "f8dc4017502e44f5ab0a6fb8026a7d9c.jpg",
                "url": "hanifah-ali/product_austrian_crystal_teardrop_leverback_dangle_earrings_for_women_fashion_14k_gold_plated_hypoallergenic_jewelry_a3b5e6_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    45.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 8.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Necklace Bracelets Set ",
        "description": "80s 90s Hip Hop Costume Outfit Rapper Accessories Chunky Gold Necklace Bracelets Set for Men Women\r\n",
        "unique_id": "HA191089P",
        "url_slug": "necklace-bracelets-set",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "bf7f88b59c1f4801a954bf264593d1b0",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "all",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-20T14:40:30",
                "id": "ab4eb4a826a2464386dc27fee53c8c3c",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-20T14:40:30",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:47:34",
        "last_updated": "2024-10-20T16:47:51",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "bf7f88b59c1f4801a954bf264593d1b0",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "5e05e6e895b44e0f87c561fc9de28822.jpg",
                "url": "hanifah-ali/product_necklace_bracelets_set_b12a95_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    60.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 30.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Silicone Wedding Band",
        "description": "Silicone Ring Wedding Band for Men - 9.4mm Width 2.5mm Thick",
        "unique_id": "HA191088P",
        "url_slug": "silicone-wedding-band",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "c0d8f07e354c4f9db6cc31ec4fedd398",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:45:45",
        "last_updated": "2024-10-20T16:46:12",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "c0d8f07e354c4f9db6cc31ec4fedd398",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "78f252081d57413aa5534b596b7b46ef.jpg",
                "url": "hanifah-ali/product_silicone_wedding_band_400cb6_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    50.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 8.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": " Short Sleeve Shirts",
        "description": "Free to Live 3 Pack Dolman Sleeve Tunic Dressy Business Casual Tops for Women Short Sleeve Shirts Work Outfits Travel Clothes",
        "unique_id": "HA191087P",
        "url_slug": "short-sleeve-shirts",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "d9545e2a7050470e91a685de8f94ff94",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:44:08",
        "last_updated": "2024-10-20T16:44:17",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "d9545e2a7050470e91a685de8f94ff94",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "e2c3c14030544547bbf812125ec95154.jpg",
                "url": "hanifah-ali/product_short_sleeve_shirts_a5c609_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    30.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 7.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Teardrop Austrian Crystal ",
        "description": "Teardrop Austrian Crystal Leverback Drop Earrings for Women 14K Rose Gold Plated Hypoallergenic Jewelry",
        "unique_id": "HA191086P",
        "url_slug": "teardrop-austrian-crystal",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "5d4ba91637e3447cb1deaafc75d81d42",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:41:57",
        "last_updated": "2024-10-20T16:42:04",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "5d4ba91637e3447cb1deaafc75d81d42",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "7198c764e8ab407885165b041d5cbfda.jpg",
                "url": "hanifah-ali/product_teardrop_austrian_crystal_a4e265_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    315.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 4.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Crucifix Pendant Necklace",
        "description": "Besteel 925 Sterling Silver Cross Necklace Beveled Edge for Men Women 5mm Stainless Steel Diamond Cut Durable Cuban Link Curb Chain Crucifix Pendant Necklace Jewelry 16-30 Inches",
        "unique_id": "HA191085P",
        "url_slug": "crucifix-pendant-necklace",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "4eae9e3428ed44e28924249a8b808d1a",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "all",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-20T14:40:30",
                "id": "ab4eb4a826a2464386dc27fee53c8c3c",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-20T14:40:30",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:30:10",
        "last_updated": "2024-10-20T16:30:26",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "4eae9e3428ed44e28924249a8b808d1a",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "b0c86536b9de4bbb9c3c28e26c6fae5b.jpg",
                "url": "hanifah-ali/product_crucifix_pendant_necklace_ec6b36_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    78.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 13.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": " Wrinkle-Free Shirt ",
        "description": "COOFANDY Mens Casual Button Down Shirts Long Sleeve Wrinkle-Free Shirt Lightweight Shirt Jacket",
        "unique_id": "HA191084P",
        "url_slug": "wrinkle-free-shirt",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "4ae9d23052a840bd9c70a8f2c33542f1",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:28:11",
        "last_updated": "2024-10-20T16:28:19",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "4ae9d23052a840bd9c70a8f2c33542f1",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "53875d253e184c9095c97fa96baaac67.jpg",
                "url": "hanifah-ali/product_wrinkle_free_shirt_2f98ae_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    18.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 67.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Rose Gold Earrings ",
        "description": "Austrian Crystal Octagon Leverback Drop Earrings for Women 14K Rose Gold Plated Hypoallergenic Jewelry",
        "unique_id": "HA191083P",
        "url_slug": "rose-gold-earrings",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "a027fd95c6df4dccaa825ce9178ab6d7",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:20:56",
        "last_updated": "2024-10-20T16:21:37",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "a027fd95c6df4dccaa825ce9178ab6d7",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "60634959a456432dad2e75ea087a53aa.jpg",
                "url": "hanifah-ali/product_rose_gold_earrings_54a3b1_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    178.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 65.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Women's Gold Stud ",
        "description": "Women's Gold Stud Earrings 2 pcs/set, Diamond Stone Luxury Design Best for Wives, 002, Mothers",
        "unique_id": "HA191082P",
        "url_slug": "women-s-gold-stud",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "9538c2eb11d441b1827bb98961704cbf",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:17:36",
        "last_updated": "2024-10-20T16:17:54",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "9538c2eb11d441b1827bb98961704cbf",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "ae29ebef37c14517bc98e24bc23ba232.jpg",
                "url": "hanifah-ali/product_women_s_gold_stud_c9f3b3_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    450.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 7.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Summe Dress Shorts",
        "description": "MAGCOMSEN Mens Casual Shorts 7 Inch Cotton Flat Front Shorts Lightweight Elastic Waist Summer Dress Shorts with Pockets",
        "unique_id": "HA191081P",
        "url_slug": "summe-dress-shorts",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "b67747f506ba4c1f944411ca8c12f093",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:15:10",
        "last_updated": "2024-10-20T16:15:21",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "b67747f506ba4c1f944411ca8c12f093",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "181beaa5e271430f99cdfa23a7046a02.jpg",
                "url": "hanifah-ali/product_summe_dress_shorts_3e3be6_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    40.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 4.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Sweatpants Cargo Joggers",
        "description": "Aleumdr Womens Sweatpants Cargo Joggers Baggy Sweat Fall Pants Athletic Cotton Fleece Lined Casual Pants with Pockets",
        "unique_id": "HA191080P",
        "url_slug": "sweatpants-cargo-joggers",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "0f7c311c0e3c443c810813dfbb666606",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:09:59",
        "last_updated": "2024-10-20T16:10:16",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "0f7c311c0e3c443c810813dfbb666606",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "e7eed6be2c02486c89e98206315ded17.jpg",
                "url": "hanifah-ali/product_sweatpants_cargo_joggers_fc44da_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    34.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 23.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Chain Bracelet Pack ",
        "description": "DEARMAY Gold Bracelets for Women Waterproof, 14K Real Gold Jewelry Sets for Women Trendy Thin Dainty Stackable Cuban Link Paperclip Chain Bracelet Pack Fashion Accessories Gifts for Womens",
        "unique_id": "HA191079P",
        "url_slug": "chain-bracelet-pack",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "80f3fda941ac4724b06f6b0727d33c48",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T16:00:56",
        "last_updated": "2024-10-20T16:01:05",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "80f3fda941ac4724b06f6b0727d33c48",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "eed1d3eddef74a2e856633d621ee1e8a.jpg",
                "url": "hanifah-ali/product_chain_bracelet_pack_5fca70_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    65.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 5.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Hooded Collar Drawstring ",
        "description": "JMIERR Mens 2024 Casual Cotton Hooded Collar Drawstring Hoodies Pullover Sweatshirts Casual Long Sleeve Shirts",
        "unique_id": "HA191078P",
        "url_slug": "hooded-collar-drawstring",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "c548ef4ed8cc4a1db6bbe26d4547aa74",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:57:33",
        "last_updated": "2024-10-20T15:57:42",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "c548ef4ed8cc4a1db6bbe26d4547aa74",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "54f0f2f3d3c84c4a8dfdf0a93714e325.jpg",
                "url": "hanifah-ali/product_hooded_collar_drawstring_9c6905_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    12.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 45.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Running Joggers",
        "description": "AUTOMET Baggy Sweatpants for Women with Pockets-Lounge Womens Pajams Pants-Womens Running Joggers Fall Clothes Outfits 2024",
        "unique_id": "HA191077P",
        "url_slug": "running-joggers",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "a4285e78b5164af4bbb8868571c51ab4",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:55:37",
        "last_updated": "2024-10-20T15:55:49",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "a4285e78b5164af4bbb8868571c51ab4",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "6e4ded577de5495ea05aead2a5e59f1a.jpg",
                "url": "hanifah-ali/product_running_joggers_2195e7_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    35.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 57.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": " Trendy Clip On Jewelry",
        "description": "Small Gold Huggie Hoop Earrings Set for Women, Hypoallergenic 14K Real Gold Plated Stack Cartilage Earring, Earrings Sets for Multiple Piercing Lightweight Mini Thin Cute Dainty Trendy Clip On Jewelry",
        "unique_id": "HA191076P",
        "url_slug": "trendy-clip-on-jewelry",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "1dad30b23c2f4496ab422d45bfaa1e8c",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "jewelries",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:07:13",
                "id": "8137cebc580845e5b8ab6dc2479d5756",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:07:13",
                "subcategories": [],
                "parents": []
            },
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:52:46",
        "last_updated": "2024-10-20T15:54:37",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "1dad30b23c2f4496ab422d45bfaa1e8c",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "341df5077d7b46859e69dac44ed91d25.jpg",
                "url": "hanifah-ali/product_trendy_clip_on_jewelry_d467f6_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    44.0,
                    44.0,
                    []
                ],
                "LRD": [
                    19.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 14.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Casual Pullover Shirt",
        "description": "Men's Crewneck Sweatshirts Soild Color Geometric Texture Long Sleeve Casual Pullover Shirt",
        "unique_id": "HA191075P",
        "url_slug": "casual-pullover-shirt",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "bda6de6800a947db8ec60d281c241b18",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:51:10",
        "last_updated": "2024-10-20T15:51:19",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "bda6de6800a947db8ec60d281c241b18",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "83bc6dfbb12b4b9dac837b96c550667c.jpg",
                "url": "hanifah-ali/product_casual_pullover_shirt_2887bc_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    30.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 22.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Sweatsuit with Pockets",
        "description": "Ekouaer Womens Waffle Knit Pajama Sets Long Sleeve Top and Shorts Matching Lounge Set Loungewear Sweatsuit with Pockets",
        "unique_id": "HA191074P",
        "url_slug": "sweatsuit-with-pockets",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "7cd36878bf6a4a7cad042bdf6fd7b256",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:49:06",
        "last_updated": "2024-10-20T15:49:14",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "7cd36878bf6a4a7cad042bdf6fd7b256",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "9f4df413a4704c5dbb70d587a973ad0d.jpg",
                "url": "hanifah-ali/product_sweatsuit_with_pockets_d87b8f_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    37.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 55.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Long Sleeve Scoop Neck V ",
        "description": null,
        "unique_id": "HA191073P",
        "url_slug": "long-sleeve-scoop-neck-v",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "aaeb1c09724a4841b14c2d9a363899a9",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:45:50",
        "last_updated": "2024-10-20T15:45:50",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "aaeb1c09724a4841b14c2d9a363899a9",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "69dd5cde28dc401d9a2eec1158e5a6ff.jpg",
                "url": "hanifah-ali/product_long_sleeve_scoop_neck_v_f7694f_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    17.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 3.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Long Sleeve Crop Tops ",
        "description": "SKYZOO Long Sleeve Crop Tops for Women 2024 Slim Fit Basic Fall Fashion Y2k Teen Girl Clothes",
        "unique_id": "HA191072P",
        "url_slug": "long-sleeve-crop-tops",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "353e9639611044838b76c0562ba7e4f4",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:43:42",
        "last_updated": "2024-10-20T15:43:56",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "353e9639611044838b76c0562ba7e4f4",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "d09efa20d86949a19c3114a72a5d80e8.jpg",
                "url": "hanifah-ali/product_long_sleeve_crop_tops_146fbd_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "LRD": [
                    19.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 6.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Fitted Crop Top ",
        "description": "QINSEN Women's Crewneck Long Sleeve Shirts Double Lined Fitted Crop Top Seam Cup Going Out Tops",
        "unique_id": "HA191071P",
        "url_slug": "fitted-crop-top",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "50fea224cc0c4fc89f943cdaf1c12118",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:41:40",
        "last_updated": "2024-10-20T18:03:40",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "50fea224cc0c4fc89f943cdaf1c12118",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "6b5f8728fa9040daa07408b094dea570.jpg",
                "url": "hanifah-ali/product_fitted_crop_top_54bc3f_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    17.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 6.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Basic Crop Top",
        "description": "Artfish Women's Square Neck Long Sleeve Ribbed Slim Fitted Casual Basic Crop Top\r\n",
        "unique_id": "HA191070P",
        "url_slug": "basic-crop-top",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "880796bf7a1d42e79e76939b994f8e68",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:39:27",
        "last_updated": "2024-10-20T15:40:04",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "880796bf7a1d42e79e76939b994f8e68",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "f6a5ebdb1b034e7f9c226255f1b06f01.jpg",
                "url": "hanifah-ali/product_basic_crop_top_8eaf51_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "LRD": [
                    18.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 7.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Trendy Queen Sweatshirts ",
        "description": "Trendy Queen Sweatshirts Half Zip Pullover Quarter Zip Oversized Hoodies Sweaters Comfy Fall Outfits 2024 Y2K Winter Clothes",
        "unique_id": "HA191069P",
        "url_slug": "trendy-queen-sweatshirts",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "67a5c8aff31048978b29a3981d391159",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:35:10",
        "last_updated": "2024-10-20T15:36:10",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "67a5c8aff31048978b29a3981d391159",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "68c348db8d1245cbb3db0162c3054004.jpg",
                "url": "hanifah-ali/product_trendy_queen_sweatshirts_cc8181_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    56.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 3.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Women's Shapewear Bodysuit",
        "description": "SHAPERX Women's Shapewear Bodysuit Tummy Control Body Shaper Seamless Sculpting Snatched Waist Body Suit",
        "unique_id": "HA191068P",
        "url_slug": "women-s-shapewear-bodysuit",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "a90e1b08d5534ccfac702beda27c22be",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:19:50",
        "last_updated": "2024-10-20T15:20:30",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "a90e1b08d5534ccfac702beda27c22be",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "4a31ab9586134b0e99f4640ea49783ad.jpg",
                "url": "hanifah-ali/product_women_s_shapewear_bodysuit_62acd2_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    22.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 1.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Lounge Legging",
        "description": "CRZ YOGA Butterluxe High Waisted Lounge Legging 25\" - Workout Leggings for Women Buttery Soft Yoga Pants",
        "unique_id": "HA191067P",
        "url_slug": "lounge-legging",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "3ee46e8328824bf69deb450cb86e97dc",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "women",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:35",
                "id": "bff99b9c6bcb4d05812a7f5beee4753d",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:35",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:17:45",
        "last_updated": "2024-10-20T15:18:03",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "3ee46e8328824bf69deb450cb86e97dc",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "cd59d5a784214e47a28fe3d1ae9ce324.jpg",
                "url": "hanifah-ali/product_lounge_legging_077a08_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    24.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 4.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": " 3 Pack Mens Sweatpants",
        "description": "Ultra Performance 3 Pack Mens Sweatpants, Fleece Cargo Joggers for Men with Pockets\r\n",
        "unique_id": "HA191066P",
        "url_slug": "3-pack-mens-sweatpants",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "06d141ad758749c09f94d71ad7ccf7d4",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:15:48",
        "last_updated": "2024-10-20T15:16:21",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "06d141ad758749c09f94d71ad7ccf7d4",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "3c7e96f5c6ec4ff491f7d2b764782119.jpg",
                "url": "hanifah-ali/product_3_pack_mens_sweatpants_27eed0_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    75.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 3.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    },
    {
        "name": "Trucker Jacket",
        "description": "Levi's Men's Sherpa Lined Trucker Jacket (Regular, Big & Tall Sizes)",
        "unique_id": "HA191065P",
        "url_slug": "trucker-jacket",
        "is_available": true,
        "is_service": false,
        "previous_url_slugs": null,
        "unavailable": false,
        "unavailable_start": null,
        "unavailable_end": null,
        "id": "4f0ac80f86a04e3b8175a2baf7b5331e",
        "parent_product_id": null,
        "parent": null,
        "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
        "product_image": [],
        "categories": [
            {
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "name": "men",
                "position": null,
                "category_type": "standard",
                "description": "",
                "last_updated": "2024-10-18T21:06:27",
                "id": "53d2683d48ac43a8ab7e52c7bfcaedce",
                "parent_id": null,
                "url_slug": null,
                "is_deleted": false,
                "date_created": "2024-10-18T21:06:27",
                "subcategories": [],
                "parents": []
            }
        ],
        "date_created": "2024-10-20T15:13:21",
        "last_updated": "2024-10-20T15:13:43",
        "user_id": "91e5cb3c45e14ec982dc8c0df73657c6",
        "photos": [
            {
                "model_name": "products",
                "model_id": "4f0ac80f86a04e3b8175a2baf7b5331e",
                "organization_id": "72fd8cdc30fe47c5b124c7cd3da6c37b",
                "filename": "4fee275e951b4020ab18e065ddc59d18.jpg",
                "url": "hanifah-ali/product_trucker_jacket_bc5b4f_1.jpg",
                "is_featured": false,
                "save_as_jpg": true,
                "is_public": true,
                "file_rename": false,
                "position": 1
            }
        ],
        "current_price": [
            {
                "USD": [
                    76.0,
                    null,
                    []
                ]
            }
        ],
        "is_deleted": false,
        "available_quantity": 4.0,
        "selling_price": null,
        "discounted_price": null,
        "buying_price": null,
        "extra_infos": null
    }
    ]

    export default productsData;